import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UpdateChargingStationsDialogContentComponent } from './update-charging-station-dialog-content/update-charging-stations-dialog-content';

@Component({
  selector: 'app-update-charging-station-dialog',
  template: ''
})
export class UpdateChargingStationDialogComponent implements OnInit {

  @Input() public chargingStations;

  constructor(public dialog: NgbModal, private activatedRoute: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.openDialog();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(UpdateChargingStationsDialogContentComponent, { centered: true, size: 'lg', backdrop: 'static' });
    dialogRef.componentInstance.stations = this.chargingStations;

    dialogRef.result.then((result) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    });
  }

}
